import { useMutation } from "@apollo/client";
import {
  ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentDocument,
  ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentQuery,
  ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrumentDocument,
  ApplicantUserUpdatePaymentInstrumentInput,
} from "../../../../generated";
import { UpdateCardModal } from "./update-card-modal";
import { Country } from "../../../../types/country";
import { message } from "antd";

interface UpdateCardModalContainerProps {
  applicantUserId: string;
  cyberSourcePublicKey: string;
  paymentInstrumentId: string | null | undefined;
  countries: Country[];
  isOpen: boolean;
  onClose: () => void;
}

export const UpdateCardModalContainer: React.FC<UpdateCardModalContainerProps> = (props) => {
  const [updatePaymentInstrument] = useMutation(ApplicantUpdateCardModalContainerApplicantUserUpdatePaymentInstrumentDocument);

  const handleUpdateCard = async (data: ApplicantUserUpdatePaymentInstrumentInput) => {
    const updateResult = await updatePaymentInstrument({
      variables: {
        input: data,
      },
      update: (cache, { data }) => {
        const cachedData = cache.readQuery<ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentQuery>({
          query: ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentDocument,
          variables: {
            applicantUserId: props.applicantUserId,
          },
        });

        if (data?.applicantUserUpdatePaymentInstrument?.paymentInstrument && cachedData) {
          const newData: ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentQuery = {
            applicantUserPaymentInstrument: data.applicantUserUpdatePaymentInstrument.paymentInstrument,
          };

          cache.writeQuery({
            query: ApplicantPaymentInstrumentDisplayContainerApplicantUserPaymentInstrumentDocument,
            variables: {
              applicantUserId: props.applicantUserId,
            },
            data: newData,
          });
        }
      },
    });
    if (updateResult.data?.applicantUserUpdatePaymentInstrument?.paymentInstrument) {
      message.success("Card updated successfully");
    } else {
      message.error("Failed to update card");
    }
  };

  return <UpdateCardModal cyberSourcePublicKey={props.cyberSourcePublicKey} countries={props.countries} onCardUpdate={handleUpdateCard} onClose={props.onClose} isOpen={props.isOpen} paymentInstrumentId={props.paymentInstrumentId} />;
};

